import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  TextField,
  Typography,
  Chip,
} from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import PersonIcon from "@mui/icons-material/Person";
import DescriptionIcon from "@mui/icons-material/Description";
import { useState } from "react";

const ConfirmRejectionDialog = ({ open, onClose, report, onReject, disabled }) => {
  const [reason, setReason] = useState("");
  const [error, setError] = useState(false);

  const handleConfirm = () => {
    if (!reason.trim()) {
      setError(true);
      return;
    }
    onReject(reason.trim());
    setReason("");
    setError(false);
  };

  if (!report) return null;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <ErrorOutlineIcon color="error" />
          <Typography variant="h6" color="error">
            Reject Report Confirmation
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent dividers>
        <Typography variant="body2" sx={{ mb: 2, color: "text.secondary" }}>
          Please confirm that you wish to reject this report.  
          Rejection should only occur when the submission does not meet
          performance expectations or contains incomplete information.
        </Typography>

        <Divider sx={{ mb: 2 }} />

        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" alignItems="center" gap={1}>
            <PersonIcon color="primary" />
            <Typography variant="body2">
              <strong>Employee:</strong> {report.employeeNames}
            </Typography>
          </Box>

          <Box display="flex" alignItems="center" gap={1}>
            <DescriptionIcon color="primary" />
            <Typography variant="body2">
              <strong>Activity:</strong> {report.name}
            </Typography>
          </Box>

          <Box display="flex" alignItems="center" gap={1}>
            <Chip
              size="small"
              label={`Target: ${report.targetShare} ${report.measurementUnit}`}
              color="primary"
              variant="outlined"
            />
            <Chip
              size="small"
              label={`Achieved: ${report.achievedTarget} ${report.measurementUnit}`}
              color="info"
              variant="outlined"
            />
          </Box>
        </Box>

        <Divider sx={{ my: 2 }} />

        <TextField
          label="Supervisor Comment (reason for rejection)"
          multiline
          fullWidth
          minRows={3}
          value={reason}
          onChange={(e) => {
            setReason(e.target.value);
            setError(false);
          }}
          error={error}
          helperText={error ? "Please provide a reason before rejecting." : ""}
        />

        <Box mt={2}>
          <Typography variant="caption" color="text.secondary">
            💡 Tip: Clearly explain what was missing or how the employee can improve
            next time.
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "space-between", px: 3, py: 2 }}>
        <Button onClick={onClose} color="inherit" variant="outlined" disabled={disabled}>
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="error"
          disabled={disabled || !reason.trim()}
        >
          Reject & Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmRejectionDialog;
